'use strict';

var React = require('react');
var index = require('../../forms/Select/index.js');
var filterPopin_styles = require('./filterPopin.styles.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

const FilterSelectPopin = ({ id, node = { current: null }, initialSort, filter, isFilterOpen = false, endColumn = false, isFirstCol = false, addToCurrentSort = () => null, removeFromCurrentSort = () => null, searchPlaceholder = 'Rechercher', defaultOrder = 'date', labelOrderTitle = 'Option de tri', labelOrderDate = 'Tri désactivé', labelOrderAsc = 'Trier de A \u2192 Z', labelOrderDesc = 'Trier de Z \u2192 A', children, selectProps, }) => {
    const [searchValue, setSearchValue] = React.useState(initialSort?.filter === filter && initialSort?.search ? initialSort.search : '');
    const [sortValue, setSortValue] = React.useState(initialSort?.filter === filter && initialSort?.order ? initialSort.order : defaultOrder);
    if (!isFilterOpen) {
        return null;
    }
    const onSortBy = (data) => {
        removeFromCurrentSort({ filter });
        if (data.search !== '' || data.order !== defaultOrder) {
            addToCurrentSort({ ...data, filter });
        }
    };
    const onInputChange = (val) => {
        setSearchValue(val);
        if (val === '' || val.length > 2) {
            onSortBy({ search: val, order: sortValue });
        }
    };
    const onRadioChange = (sortVal) => (e) => {
        setSortValue(e.target.value);
        onSortBy({ search: searchValue, order: sortVal });
    };
    return (React__default.default.createElement(filterPopin_styles.ContainerStyled, { id: id, ref: node, endColumn: endColumn, isFirstCol: isFirstCol },
        React__default.default.createElement(index.Select.Control, { id: `${id}-search`, onFocus: e => e.stopPropagation(), placeholder: searchPlaceholder, value: searchValue, onChange: onInputChange, ...selectProps },
            React__default.default.createElement(index.Select.Option, { value: "", label: "-" }),
            children),
        React__default.default.createElement(filterPopin_styles.FilterDiv, null, labelOrderTitle),
        React__default.default.createElement(filterPopin_styles.FlexDiv, null,
            React__default.default.createElement(filterPopin_styles.Radio, { id: `${id}-date`, name: "filter", value: "date", checked: sortValue === 'date', onChange: onRadioChange('date') }),
            React__default.default.createElement(filterPopin_styles.LabelStyled, { htmlFor: `${id}-date` }, labelOrderDate)),
        React__default.default.createElement(filterPopin_styles.FlexDiv, null,
            React__default.default.createElement(filterPopin_styles.Radio, { id: `${id}-asc`, name: "filter", value: "asc", checked: sortValue === 'asc', onChange: onRadioChange('asc') }),
            React__default.default.createElement(filterPopin_styles.LabelStyled, { htmlFor: `${id}-asc` }, labelOrderAsc)),
        React__default.default.createElement(filterPopin_styles.FlexDiv, null,
            React__default.default.createElement(filterPopin_styles.Radio, { id: `${id}-desc`, name: "filter", value: "desc", checked: sortValue === 'desc', onChange: onRadioChange('desc') }),
            React__default.default.createElement(filterPopin_styles.LabelStyled, { htmlFor: `${id}-desc` }, labelOrderDesc))));
};

exports.FilterSelectPopin = FilterSelectPopin;
//# sourceMappingURL=filterSelectPopin.js.map
